export const getYoutubeId = (link: string) => {
  let url: URL;
  try {
    url = new URL(link);
  } catch {
    return null;
  }
  let videoId = url.searchParams.get('v');
  if (!videoId && link.includes('youtu.be/')) {
    videoId = url.pathname.split('/')[1];
  }
  if (!videoId && link.includes('youtube.com/embed/')) {
    videoId = url.pathname.split('/')[2];
  }
  // https://www.youtube.com/shorts/pVb7pCzThTk
  if (!videoId && link.includes('youtube.com/shorts/')) {
    videoId = url.pathname.split('/')[2];
  }
  return videoId;
};
